import { writable } from 'svelte/store'

/*
Subscription Rules:
  - Must have shipment available
  - Must have rentals_per_shipment > 0
  - Must be active
  - If active == false, the subscriber paused their membership
  - Cannot rent if the user has rentals out
  - Cannot rent more than rentals_per_shipment
  - Cannot buy a puzzle pack if they are a subscriber
*/
function createSubscription() {
  let init = {
    errorMsg: null,
    itemCount: 0,
    initialized: false,
    active: false,
    valid: false,
    hasSubscription: false,
    validErrMessage: null,
    startDate: null,
  }
  const { subscribe, set, update } = writable({})

  return {
    subscribe,

    setSubscriptionDetails: (details) => {
      if (
        details === null ||
        (Object.keys(details).length === 0 && details.constructor === Object)
      ) {
        update((s) => init)
        return
      }

      update((sub) => {
        sub.hasSubscription = true
        sub.active = details.active
        sub.maxPuzzles = details.rentals_per_shipment
        sub.shipments_available = details.shipments_available
        sub.memberId = details.membership_id
        sub.hasRentalsOut = details.has_rentals
        sub.startDate = details.start_date
        sub.itemCount = sub.itemCount || 0
        if (details.shipments_available <= 0) {
          sub.valid = false
          sub.validErrMessage =
            'You have no more shipments available this month.'
        } else if (details.has_rentals) {
          sub.valid = false
          sub.validErrMessage = 'You have the max number of rentals out.'
        } else if (!details.active) {
          sub.valid = false
          sub.validErrMessage = 'Your membership is paused.'
        } else {
          sub.valid = true
        }
        return sub
      })
    },

    setError: (err) => {
      update((sub) => {
        sub.errorMsg = err
        return sub
      })
    },

    clearError: () => {
      update((sub) => {
        sub.errorMsg = null
        return sub
      })
    },

    addItem: () => {
      update((sub) => {
        sub.itemCount++
        return sub
      })
    },

    removeItem: () => {
      update((sub) => {
        sub.itemCount--
        return sub
      })
    },

    isFull: () => {
      let isFull = false

      subscribe((sub) => {
        if (sub.itemCount === sub.maxPuzzles) {
          isFull = true
        }
      })
      return isFull
    },

    setInit: (init) => {
      update((sub) => {
        sub.initialized = init
        return sub
      })
    },

    isInit: () => {
      let init = false
      subscribe((s) => {
        init = true
      })
      return init
    },

    setCount: (items) => {
      let itemCount = 0
      for (let i in items) {
        if (items[i].product_type.name === 'Puzzle (Rental)') {
          itemCount += items[i].quantity
        }
      }
      if (itemCount > 0) {
        update((sub) => {
          sub.initialized = true
          sub.itemCount = itemCount
          return sub
        })
      }
    },

    // Checks that the number of rentals in cart is a valid amount.
    checkItemCountValid: () => {
      let valid = true
      let msg = ''
      update((sub) => {
        // Must have more than zero. We could also let people just give away
        // their money. That's cool.
        if (sub.itemCount <= 0) {
          valid = false
          msg =
            'You have no puzzle rentals in your cart! ' +
            'Please select at least one puzzle rental to checkout.'

          // If they somehow added too many puzzle packs. That's not cool.
        } else if (sub.itemCount > sub.maxPuzzles) {
          valid = false
          msg =
            'You have too many rentals in your cart! ' +
            'Remove puzzle rentals to checkout!'
        }

        return sub
      })

      return {
        valid: valid,
        message: msg,
      }
    },

    reset: () => {
      update((sub) => {
        sub.itemCount = 0
        sub.initialized = false
        return sub
      })
    },
  }
}

export let subscription = createSubscription()
